/**
 * Global flash helper emmiting a flash event
 * See the FlashStack Component (listening for this event) for more details
 * Use: flash({message: 'msg', level: 'success|info|warning|danger});
 */

import { EventBus } from '../components/eventbus.js';

export default (param) => {
    const isSingleMessage = !!param.message;
    const isAxios = !!param.data && param.data.flash;

    if (isSingleMessage) {
        EventBus.$emit('flash', param);
        return;
    }

    if (isAxios) {
        param.data.flash.map((message) => {
            EventBus.$emit('flash', message);
        });
        return;
    }
}